import { Form, Formik } from "formik";
import Title from "../../components/common/title/Title";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import { postApi, putApi } from "../../services/api/globalApi";
import Input from "../../components/common/inputs/Input";
import Button from "../../components/common/button/Button";
import { useLocation, useNavigate } from "react-router";
import ImagesModal from "../../components/common/modals/imgaes-modal/ImagesModal";
import { useRef, useState } from "react";
import * as Yup from "yup";
import { fileUrl } from "../../services/config";
import Textarea from "../../components/common/inputs/TextArea";

const teamMemberValidation = Yup.object().shape({
  name: Yup.string().required("نام الزامی است"),
  role: Yup.string().required("سمت الزامی است"),
  shortTagline: Yup.string(),
  description: Yup.string().required("توضیحات الزامی است"),
});

export default function TeamMemberForm() {
  const location = useLocation();
  const navigate = useNavigate();

  const [image, setImage] = useState(location?.state?.image || "");

  const formHandler = async (values, { resetForm }) => {
    if (!image) {
      warningMessage("لطفا تصویر عضو تیم را انتخاب کنید");
      return;
    }

    const body = {
      ...values,
      image,
      isActive: values.isActive === "true" || values.isActive === true,
    };

    try {
      if (location.state) {
        await putApi({
          path: `admin/team-members/${location.state?._id}`,
          body: JSON.stringify(body),
        });
        successMessage("عضو تیم با موفقیت ویرایش شد");
      } else {
        await postApi({
          path: "admin/team-members",
          body: JSON.stringify(body),
        });
        successMessage("عضو تیم با موفقیت اضافه شد");
      }
      resetForm();
      navigate("/team-member-list");
    } catch (error) {
      console.error(error);
      errorMessage(
        error?.response?.data?.errors?.[0]?.message || "خطا در انجام عملیات"
      );
    }
  };

  const imageModal = useRef();

  const selectedImages = (item) => {
    if (item) {
      setImage(item.name);
      successMessage("عکس اضافه شد.");
    }
  };

  return (
    <>
      <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
        <Title
          title={location?.state ? "ویرایش عضو تیم" : "افزودن عضو تیم"}
        />
        <Formik
          enableReinitialize
          initialValues={{
            name: location?.state?.name || "",
            role: location?.state?.role || "",
            shortTagline: location?.state?.shortTagline || "",
            description: location?.state?.description || "",
            isActive: location?.state?.isActive ?? true,
          }}
          validationSchema={teamMemberValidation}
          onSubmit={formHandler}
        >
          {({ values }) => (
            <Form>
              <div className="mt-6">
                <div className="grid gap-6 mb-4 md:grid-cols-2">
                  <Input
                    name="name"
                    placeholder="نام و نام خانوادگی"
                    label="نام و نام خانوادگی"
                    type="text"
                  />

                  <Input
                    name="role"
                    placeholder="سمت"
                    label="سمت"
                    type="text"
                  />

                  <Input
                    name="shortTagline"
                    placeholder="شعار کوتاه"
                    label="شعار کوتاه"
                    type="text"
                  />

                  <div className="mb-3">
                    <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      وضعیت
                    </label>
                    <select
                      name="isActive"
                      onChange={(e) => {
                        values.isActive = e.target.value === "true";
                      }}
                      defaultValue={values.isActive}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    >
                      <option value="true">فعال</option>
                      <option value="false">غیرفعال</option>
                    </select>
                  </div>
                </div>

                <div className="grid gap-6 mb-4 md:grid-cols-2">
                  <div>
                    <Textarea
                      name="description"
                      placeholder="توضیحات"
                      label="توضیحات"
                      rows={4}
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      تصویر
                    </label>
                    {image ? (
                    <div className="bg-gray-50 border border-gray-300 rounded-lg p-3 dark:bg-gray-700 dark:border-gray-600">
                      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                        <div className="w-14 h-14 rounded-lg overflow-hidden border border-gray-200 dark:border-gray-500 flex-shrink-0">
                          <img
                            src={
                              image.startsWith("http")
                                ? image
                                : `${fileUrl}files/thumb_${image}`
                            }
                            className="w-full h-full object-cover"
                            alt="Preview"
                          />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-medium text-gray-900 dark:text-white truncate">
                            {image}
                          </p>
                        </div>
                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() => imageModal.current.showModal()}
                            className="px-3 py-1.5 text-xs font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 dark:bg-blue-900/30 dark:text-blue-400 dark:hover:bg-blue-900/50"
                          >
                            تغییر
                          </button>
                          <button
                            type="button"
                            onClick={() => setImage("")}
                            className="px-3 py-1.5 text-xs font-medium text-red-600 bg-red-50 rounded-lg hover:bg-red-100 dark:bg-red-900/30 dark:text-red-400 dark:hover:bg-red-900/50"
                          >
                            حذف
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      onClick={() => imageModal.current.showModal()}
                      className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-6 text-center cursor-pointer hover:border-blue-400 hover:bg-blue-50/50 transition-colors dark:bg-gray-700 dark:border-gray-600 dark:hover:border-blue-500 dark:hover:bg-blue-900/20"
                    >
                      <div className="flex flex-col items-center">
                        <svg
                          className="w-8 h-8 text-gray-400 mb-2"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                          />
                        </svg>
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                          کلیک کنید برای انتخاب تصویر
                        </p>
                      </div>
                    </div>
                  )}
                  </div>
                </div>

                <div className="flex flex-col gap-y-2">
                  <div className="mt-6">
                    <Button
                      text={location?.state ? "ویرایش" : "افزودن"}
                      type={"submit"}
                      color={"success"}
                    />
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <ImagesModal selectedImages={selectedImages} ref={imageModal} />
    </>
  );
}
